export default {
    XS1: 'xs1',
    XS1_SUBSCRIPTION: 'xs1-subscription',
    XS1_ACCESSORY: 'xs1-accessory',

    XP1: 'xp1',
    XP1_SUBSCRIPTION: 'xp1-subscription',
    XP1_BAR: 'xp1-bar',
    XS1_ACCESSORY_TREE: 'xs1-accessory-tree'
};
